var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',{staticClass:"tabs-shadow-none",attrs:{"position":"left"}},[_c('vs-tab',{attrs:{"icon-pack":"feather","icon":"icon-user","label":"E-mail signature"}},[_c('div',{staticClass:"tab-general md:ml-4 md:mt-0 mt-4 ml-0"},[_c('email-my-signature')],1)]),(
      _vm.hasPermission(
        'vp.crm.engageconfiguration.emailsynclist.view'
      )
    )?_c('vs-tab',{attrs:{"icon-pack":"feather","icon":"icon-mail","label":"Google Groups Sync"}},[_c('div',{staticClass:"tab-general md:ml-4 md:mt-0 mt-4 ml-0"},[_c('email-sync-list')],1)]):_vm._e(),(
      _vm.hasPermission(
        'vp.crm.engageconfiguration.messengersync.view'
      )
    )?_c('vs-tab',{attrs:{"icon-pack":"feather","icon":"icon-facebook","label":"Facebook Pages Sync"}},[_c('div',{staticClass:"tab-general md:ml-4 md:mt-0 mt-4 ml-0"},[_c('messenger-sync-list')],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }